import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-embed',
  templateUrl: './video-embed.component.html',
  styleUrls: ['./video-embed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoEmbedComponent {
  private sanitizer = inject(DomSanitizer);

  readonly url = input.required<string>();
  public readonly cleanUrl = computed(() => this.clean(this.url()));

  private clean(url: string): SafeResourceUrl {
    let cleanUrl = url.replace('watch?v=', 'embed/');
    return this.sanitizer.bypassSecurityTrustResourceUrl(cleanUrl);
  }
}
